import React, { useState } from "react";
import AdminIntegratedDashboard from "./AdminIntegratedDashboard";
import { buildPaymentLinkMessage } from "../paymentLinkMessage";

type QaScenario = "DATA" | "EMPTY" | "LOADING" | "ERROR" | "TRUNCATED";

const QA_NOW = new Date("2026-08-31T03:00:00.000Z");
const SYNTHETIC_BUYLINK_MESSAGE = buildPaymentLinkMessage({
  requestType: "BUYLINK",
  paymentUrl: "https://synthetic.invalid/customer-payment",
  itemName: "합성 식자재 대금",
  amount: 8381000,
  customerName: "합성 거래처",
  urlExpireDate: "20260901",
});

const SYNTHETIC_CONTRACTS = [
  {
    id: "qa-contract-completed-today",
    status: "completed",
    agentName: "합성 오늘완료 거래처",
    agentBizNo: "111-11-11111",
    submittedAt: "2026-08-30T01:00:00.000Z",
    completedAt: "2026-08-31T01:30:00.000Z",
    salesReceipt: { managerName: "4영훈은옥" },
    salesRepDepartmentPart: "4파트",
    contractCompanyBranch: {
      corporationName: "농업회사법인 주식회사 씨앤푸드",
    },
    representativeIdentityVerification: { status: "MATCHED" },
    signatureEvidence: {
      valid: true,
      signatureHash: "synthetic-signature-hash-today",
    },
  },
  {
    id: "qa-contract-completed-long-name",
    status: "confirmed",
    agentName:
      "합성 매우 긴 거래처명 서울특별시 본점 및 경기남부·충청·호남 통합 물류 운영 테스트 지점",
    businessNumber: "222-22-22222",
    submittedAt: "2026-08-03T02:00:00.000Z",
    completedAt: "2026-08-04T02:30:00.000Z",
    managerName: "3승현",
    salesPart: "11파트",
    companyBranchName: "주식회사 씨앤푸드",
    representativeIdentityVerification: { status: "VERIFIED" },
    signedAt: "2026-08-04T02:20:00.000Z",
  },
  {
    id: "qa-contract-corep-pending",
    status: "pending_co_rep_verification",
    contractStatus: "PENDING_CO_REP_VERIFICATION",
    agentName: "합성 공동대표 인증 대기 거래처",
    agentBizNo: "333-33-33333",
    submittedAt: "2026-08-24T04:00:00.000Z",
    managerName: "4영훈은옥",
    salesRepDepartmentPart: "4파트",
    companyBranchName: "농업회사법인 주식회사 씨앤푸드",
    representativeIdentityVerification: { status: "MATCHED" },
    coRepresentativeWorkflow: {
      required: true,
      pendingCount: 1,
      status: "PENDING",
    },
  },
  {
    id: "qa-contract-stalled",
    status: "pending",
    agentName: "합성 장기 확인 대기 거래처",
    agentBizNo: "444-44-44444",
    submittedAt: "2026-08-18T05:00:00.000Z",
    managerName: "3승현",
    salesPart: "11파트",
    companyBranchName: "주식회사 씨앤푸드",
    representativeIdentityVerification: { status: "MATCHED" },
  },
  {
    id: "qa-contract-system-error",
    status: "error",
    agentName: "합성 계약 오류 거래처",
    agentBizNo: "555-55-55555",
    submittedAt: "2026-08-28T06:00:00.000Z",
    errorCode: "permission-denied",
    errorMessage: "합성 권한 오류",
    managerName: "4영훈은옥",
    salesPart: "4파트",
    companyBranchName: "농업회사법인 주식회사 씨앤푸드",
  },
  {
    id: "qa-contract-empty-fields",
    status: "completed",
    agentName:
      "합성 빈값 호환성 및 매우 긴 업체명 표시 안정성 확인용 거래처 본점·제1공장·제2물류센터 통합",
    agentBizNo: "",
    submittedAt: "2026-08-09T07:00:00.000Z",
    completedAt: "2026-08-10T07:30:00.000Z",
    managerName: null,
    salesPart: null,
    companyBranchName: null,
    representativeIdentityVerification: { status: "MATCHED" },
    signatureCompletedAt: "2026-08-10T07:20:00.000Z",
  },
];

const SYNTHETIC_PAYMENTS = [
  {
    paymentRequestId: "qa-payment-approved-large",
    requestType: "BUYLINK",
    status: "APPROVED",
    approvalStatus: "APPROVED",
    amount: "9,876,543,210",
    remainingAmount: 9_876_543_210,
    cancelledAmount: 0,
    createdAt: "2026-08-05T01:00:00.000Z",
    linkRegisteredAt: "2026-08-05T01:05:00.000Z",
    approvedAt: "2026-08-06T02:00:00.000Z",
    paymentUrl: "https://synthetic.invalid/approved",
    transactionId: "10000000000001",
    approvalCode: "QA000001",
    urlExpireDate: "20260801",
    vendorBusinessNumber: "111-11-11111",
    vendorBusinessName: "합성 오늘완료 거래처",
    paymentCompanyName: "농업회사법인 주식회사 씨앤푸드",
    createdBy: "4영훈은옥",
  },
  {
    paymentRequestId: "qa-payment-partial-cancel",
    requestType: "BUYLINK",
    status: "PARTIALLY_CANCELED",
    approvalStatus: "APPROVED",
    amount: "250,000,000",
    remainingAmount: 200_000_000,
    cancelledAmount: 50_000_000,
    createdAt: "2026-08-11T01:00:00.000Z",
    linkRegisteredAt: "2026-08-11T01:05:00.000Z",
    approvedAt: "20260812123045",
    paymentUrl: "https://synthetic.invalid/partial",
    transactionId: "10000000000002",
    approvalCode: "QA000002",
    urlExpireDate: "20260820",
    vendorBusinessNumber: "222-22-22222",
    vendorBusinessName:
      "합성 매우 긴 거래처명 서울특별시 본점 및 경기남부·충청·호남 통합 물류 운영 테스트 지점",
    paymentCompanyName: "주식회사 씨앤푸드",
    createdBy: "3승현",
  },
  {
    paymentRequestId: "qa-payment-canceled",
    requestType: "STANDARD",
    status: "CANCELED",
    approvalStatus: "APPROVED",
    amount: 33_000_000,
    remainingAmount: 0,
    cancelledAmount: 33_000_000,
    createdAt: "2026-08-13T01:00:00.000Z",
    approvedAt: "2026-08-13T02:00:00.000Z",
    transactionId: "10000000000003",
    approvalCode: "QA000003",
    vendorBusinessNumber: "333-33-33333",
    vendorBusinessName: "합성 공동대표 인증 대기 거래처",
    paymentCompanyName: "농업회사법인 주식회사 씨앤푸드",
    createdBy: "4영훈은옥",
  },
  {
    paymentRequestId: "qa-payment-outstanding-old-1",
    requestType: "BUYLINK",
    status: "LINK_READY",
    approvalStatus: "WAITING_CUSTOMER",
    amount: 75_000_000,
    createdAt: "2026-08-15T01:00:00.000Z",
    linkRegisteredAt: "2026-08-15T01:05:00.000Z",
    paymentUrl: "https://synthetic.invalid/waiting-1",
    urlExpireDate: "20260820",
    vendorBusinessNumber: "444-44-44444",
    vendorBusinessName: "합성 장기 미결제 거래처",
    paymentCompanyName: "주식회사 씨앤푸드",
    createdBy: "3승현",
  },
  {
    paymentRequestId: "qa-payment-outstanding-old-2",
    requestType: "BUYLINK",
    status: "LINK_READY",
    approvalStatus: "WAITING_CUSTOMER",
    amount: 75_000_000,
    createdAt: "2026-08-16T01:00:00.000Z",
    linkRegisteredAt: "2026-08-16T01:05:00.000Z",
    paymentUrl: "https://synthetic.invalid/waiting-2",
    urlExpireDate: "20260831",
    vendorBusinessNumber: "444-44-44444",
    vendorBusinessName: "합성 장기 미결제 거래처 중복 요청 의심",
    paymentCompanyName: "주식회사 씨앤푸드",
    createdBy: "3승현",
  },
  {
    paymentRequestId: "qa-payment-outstanding-future",
    requestType: "BUYLINK",
    status: "LINK_READY",
    approvalStatus: "WAITING_CUSTOMER",
    amount: 25_000_000,
    createdAt: "2026-08-30T01:00:00.000Z",
    linkRegisteredAt: "2026-08-30T01:05:00.000Z",
    paymentUrl: "https://synthetic.invalid/waiting-future",
    urlExpireDate: "20260901",
    vendorBusinessNumber: "666-66-66666",
    vendorBusinessName: "합성 유효 링크 거래처",
    paymentCompanyName: "주식회사 씨앤푸드",
    createdBy: "3승현",
  },
  {
    paymentRequestId: "qa-payment-outstanding-missing-expiry",
    requestType: "BUYLINK",
    status: "LINK_READY",
    approvalStatus: "WAITING_CUSTOMER",
    amount: 10_000_000,
    createdAt: "2026-08-29T01:00:00.000Z",
    linkRegisteredAt: "2026-08-29T01:05:00.000Z",
    paymentUrl: "https://synthetic.invalid/waiting-missing-expiry",
    vendorBusinessNumber: "777-77-77777",
    vendorBusinessName: "합성 과거 만료일 누락 거래처",
    paymentCompanyName: "주식회사 씨앤푸드",
    createdBy: "3승현",
  },
  {
    paymentRequestId: "qa-payment-failed-repeated",
    requestType: "STANDARD",
    status: "FAILED",
    approvalStatus: "FAILED",
    amount: 1_250_000,
    createdAt: "2026-08-30T01:00:00.000Z",
    linkRegisteredAt: "2026-08-30T01:05:00.000Z",
    paymentUrl: "https://synthetic.invalid/failed",
    errorCode: "KCP_APPROVAL_FAILED",
    errorMessage: "합성 KCP 승인 실패",
    attemptCount: 3,
    vendorBusinessNumber: "555-55-55555",
    vendorBusinessName: "합성 반복 승인 실패 거래처",
    paymentCompanyName: "농업회사법인 주식회사 씨앤푸드",
    createdBy: "4영훈은옥",
  },
  {
    paymentRequestId: "qa-payment-empty-fields",
    requestType: "BUYLINK",
    status: "DRAFT",
    amount: null,
    createdAt: "2026-08-31T02:00:00.000Z",
    vendorBusinessNumber: "",
    vendorBusinessName: "",
    paymentCompanyName: null,
    createdBy: null,
  },
];

const SCENARIO_OPTIONS: Array<{ value: QaScenario; label: string }> = [
  { value: "DATA", label: "합성 데이터" },
  { value: "EMPTY", label: "전체 빈 상태" },
  { value: "LOADING", label: "결제 로딩" },
  { value: "ERROR", label: "결제 권한 오류" },
  { value: "TRUNCATED", label: "5,000건 상한" },
];

export default function AdminDashboardQaHarness() {
  const [scenario, setScenario] = useState<QaScenario>("DATA");
  const [lastRange, setLastRange] = useState("대기");
  const [lastAction, setLastAction] = useState("대기");
  const empty = scenario === "EMPTY";
  const paymentsUnavailable = ["EMPTY", "LOADING", "ERROR"].includes(scenario);

  return (
    <main
      className="min-h-screen bg-slate-100 p-3 sm:p-6"
      data-testid="admin-dashboard-qa"
    >
      <div className="mx-auto max-w-[1800px] space-y-4">
        <section className="rounded-2xl bg-slate-950 p-4 text-white shadow-sm sm:p-5">
          <p className="text-xs font-black uppercase tracking-[0.18em] text-blue-300">
            Synthetic Read-only QA
          </p>
          <h1 className="mt-2 text-xl font-black sm:text-2xl">
            본사 통합 현황 대시보드 합성 QA
          </h1>
          <p className="mt-2 break-keep text-sm font-bold leading-6 text-slate-300">
            실제 API·Firestore·KCP를 호출하지 않습니다. 긴 값, 빈 필드, 공동대표
            대기와 결제 승인·취소·미결제·실패 상태만 합성 데이터로 검증합니다.
          </p>
          <div className="mt-4 flex flex-wrap gap-2">
            {SCENARIO_OPTIONS.map((option) => (
              <button
                key={option.value}
                type="button"
                onClick={() => {
                  setScenario(option.value);
                  setLastAction(`시나리오 전환: ${option.label}`);
                }}
                className={`min-h-[44px] rounded-xl px-4 py-2 text-sm font-black ${
                  scenario === option.value
                    ? "bg-white text-slate-950"
                    : "bg-slate-800 text-slate-200"
                }`}
              >
                {option.label}
              </button>
            ))}
          </div>
          <div className="mt-4 grid grid-cols-1 gap-2 text-xs font-bold text-slate-300 sm:grid-cols-2">
            <output className="rounded-xl bg-slate-900 px-3 py-2" data-testid="qa-payment-range">
              요청 범위: {lastRange}
            </output>
            <output className="rounded-xl bg-slate-900 px-3 py-2" data-testid="qa-dashboard-action">
              최근 동작: {lastAction}
            </output>
          </div>
        </section>

        <section className="rounded-2xl border border-blue-100 bg-white p-4 shadow-sm sm:p-5">
          <p className="text-xs font-black uppercase tracking-[0.18em] text-blue-700">
            Synthetic Message Preview
          </p>
          <h2 className="mt-2 text-lg font-black text-slate-950">
            BUYLINK 고객 문자 문구 미리보기
          </h2>
          <pre className="mt-3 whitespace-pre-wrap break-all rounded-xl bg-slate-950 p-4 text-xs font-bold leading-6 text-slate-100" data-testid="qa-buylink-message-preview">
            {SYNTHETIC_BUYLINK_MESSAGE}
          </pre>
        </section>

        <AdminIntegratedDashboard
          contracts={empty ? [] : SYNTHETIC_CONTRACTS}
          payments={paymentsUnavailable ? [] : SYNTHETIC_PAYMENTS}
          paymentMeta={{
            loaded: !["LOADING", "ERROR"].includes(scenario),
            truncated: scenario === "TRUNCATED",
            total: scenario === "TRUNCATED" ? 5_000 : paymentsUnavailable ? 0 : SYNTHETIC_PAYMENTS.length,
            dateFrom: "2026-08-01",
            dateTo: "2026-08-31",
          }}
          paymentLoading={scenario === "LOADING"}
          paymentError={scenario === "ERROR" ? "permission-denied" : ""}
          onPaymentRangeChange={({ dateFrom, dateTo }) =>
            setLastRange(`${dateFrom} ~ ${dateTo}`)
          }
          onReloadPayments={({ dateFrom, dateTo }) =>
            setLastAction(`합성 결제 새로고침: ${dateFrom} ~ ${dateTo}`)
          }
          onOpenContractList={() => setLastAction("기존 계약 목록 보기")}
          onOpenPaymentList={() => setLastAction("기존 결제 목록 보기")}
          now={QA_NOW}
        />
      </div>
    </main>
  );
}
